import React from 'react';
import { ReactComponent as TicketIcon } from '../assets/icons/ticket-entries.svg';
import '../styles/ActivityEntries.css';

// The Dream entries a row earned, as the app's entries chip: the ticket glyph and the count.
export default function ActivityEntries({ count }) {
  return (
    <span className="activity-entries">
      <TicketIcon className="activity-entries-icon" aria-hidden="true" />
      {(Number(count) || 0).toLocaleString('en-US')}
    </span>
  );
}
